<template>
    <div class="card border-primary border-darken-1">
        <div class="card-body">
            <h5 class="card-title mb-1 text-primary mb-2">
                {{ localizationStore.translate("lob.settings") }}
            </h5>
            <a :href="lobSettingStore.homepage" target="_blank" class="btn-sm btn-outline-primary">
                <i data-feather="external-link" class="mr-25"></i>
                <span>{{ localizationStore.translate("lob.title") }}</span>
            </a>
            <div class="row mt-2">
                <div class="col-12">
                    <div class="form-group">
                        <div class="controls">
                            <label for="lob-api-key">
                                {{ localizationStore.translate("lob.api.key") }}
                            </label>
                            <input
                                type="text"
                                required
                                class="form-control"
                                :placeholder="localizationStore.translate('lob.api.key.placeholder')"
                                id="lob_key"
                                name="lob_key"
                                v-model="lobSettingStore.lobSetting.lob_key"
                                :data-validation-required-message="localizationStore.translate('lob.api.key.error.message')"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <div class="controls">
                            <label for="live_lob_key">
                                {{ localizationStore.translate("live.lob.api.key") }}
                            </label>
                            <input
                                type="text"
                                required
                                class="form-control"
                                :placeholder="localizationStore.translate('lob.api.key.placeholder')"
                                id="live_lob_key"
                                name="live_lob_key"
                                v-model="lobSettingStore.lobSetting.live_lob_key"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <label for="mode">
                        {{ localizationStore.translate("lob.mode") }}
                    </label>
                    <div class="demo-inline-spacing">
                        <div class="custom-control custom-radio mt-0">
                            <input
                                type="radio"
                                id="mode_off"
                                required
                                name="mode"
                                class="custom-control-input"
                                v-model="lobSettingStore.lobSetting.mode"
                                value="0"
                            />
                            <label class="custom-control-label" for="mode_off">
                                {{ localizationStore.translate("lob.api.service.test") }}
                            </label>
                        </div>
                        <div class="custom-control custom-radio mt-0">
                            <input
                                type="radio"
                                id="mode_on"
                                required
                                name="mode"
                                class="custom-control-input"
                                v-model="lobSettingStore.lobSetting.mode"
                                value="1"
                            />
                            <label class="custom-control-label" for="mode_on">
                                {{ localizationStore.translate("lob.api.service.live") }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <button @click="lobSettingStore.updateLobSetting()" class="btn btn-primary mt-2 mr-1">
                        {{ localizationStore.translate("save.changes") }}
                    </button>
                    <button type="reset" class="btn btn-outline-secondary mt-2">
                        {{ localizationStore.translate("cancel") }}
                    </button>
                </div>
            </div>            
        </div>
    </div>
</template>

<script>
    import { defineComponent, ref, onBeforeMount } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useLobSettingStore } from '../../stores/LobSettingStore.js'

    export default defineComponent({
        name: 'LobSetting',
        props: {
        },
        components: {
        },
        setup(props) {
            return {
                localizationStore: useLocalizationStore(),
                lobSettingStore: useLobSettingStore()
            }
        },
        mounted() {
            useLobSettingStore().fetchLobSetting();
        },
        created() {
        },
        methods: {
        }
    });
</script>
